var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlarmBell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.892,
    height: 21.986,
    viewBox: "0 0 26.892 21.986",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1043",
    "data-name": "Group 1043",
    transform: "translate(-897.577 -645.605)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_530",
    "data-name": "Path 530",
    transform: "translate(-3.485 -2.878)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M914.716,667.826c9.519.064,8-2.561,8-2.561A7.372,7.372,0,0,1,921.3,662.9c-.769-1.774-.591-6.151-.591-6.151-.71-5.145-6.2-5.5-6.2-5.5s-5.267.231-6.23,5.206c0,0,.214,4.921-.856,6.847l-1.07,1.765S903.717,667.752,914.716,667.826Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 915.0573120117188 666.327392578125 C 918.8636474609375 666.327392578125 920.4392700195312 665.8595581054688 921.044921875 665.5755615234375 C 920.7288818359375 665.1194458007812 920.3329467773438 664.4471435546875 919.9207153320312 663.4957885742188 C 919.522216796875 662.5764770507812 919.2910766601562 661.177001953125 919.2140502929688 659.2173461914062 C 919.1710815429688 658.1240844726562 919.1912841796875 657.184326171875 919.2018432617188 656.8331298828125 C 918.9568481445312 655.2880249023438 918.1527709960938 654.180419921875 916.7467041015625 653.4496459960938 C 915.7595825195312 652.9366455078125 914.7869262695312 652.78857421875 914.49267578125 652.753662109375 C 914.2074584960938 652.7820434570312 913.2777709960938 652.9064331054688 912.3135986328125 653.3806762695312 C 910.95849609375 654.0472412109375 910.107666015625 655.123779296875 909.7827758789062 656.5820922851562 C 909.7949829101562 656.999267578125 909.8137817382812 658.038330078125 909.7484130859375 659.23681640625 C 909.6277465820312 661.4484252929688 909.2955932617188 663.0159301757812 908.73291015625 664.02880859375 C 908.7237548828125 664.0452880859375 908.7142944335938 664.0615844726562 908.7045288085938 664.0777587890625 L 907.818115234375 665.5406494140625 C 908.4932250976562 665.82421875 910.280517578125 666.2963256835938 914.7256469726562 666.3262939453125 C 914.8367309570312 666.3270263671875 914.94775390625 666.327392578125 915.0567626953125 666.327392578125 L 915.0573120117188 666.327392578125 M 915.0557250976562 667.827392578125 C 914.9444580078125 667.827392578125 914.8300170898438 667.8270263671875 914.715576171875 667.8262329101562 C 903.716552734375 667.7521362304688 906.35205078125 665.0656127929688 906.35205078125 665.0656127929688 L 907.421630859375 663.3004150390625 C 908.4912109375 661.3749389648438 908.2774658203125 656.453857421875 908.2774658203125 656.453857421875 C 909.2403564453125 651.4794311523438 914.5074462890625 651.2479858398438 914.5074462890625 651.2479858398438 C 914.5074462890625 651.2479858398438 919.995849609375 651.6029663085938 920.70556640625 656.748291015625 C 920.70556640625 656.748291015625 920.5279541015625 661.1250610351562 921.2969970703125 662.8992309570312 C 922.0657958984375 664.6735229492188 922.7161865234375 665.264892578125 922.7161865234375 665.264892578125 C 922.7161865234375 665.264892578125 924.1998901367188 667.8276977539062 915.0557250976562 667.827392578125 Z",
    stroke: "none",
    fill: "#005682"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    d: "M922.655,648.664s-.487-2.148,1.574-2.309c0,0,1.714.124,1.486,2.309",
    transform: "translate(-13.207)",
    fill: "none",
    stroke: "#005682",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    d: "M947.657,664.278a8.237,8.237,0,0,1,0,5.991",
    transform: "translate(-27.941 -10.541)",
    fill: "none",
    stroke: "#005682",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M952.073,662.59a10.417,10.417,0,0,1,0,7.435",
    transform: "translate(-29.104 -9.549)",
    fill: "none",
    stroke: "#005682",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    d: "M920.5,691.3a2.44,2.44,0,0,0,2.425,1.976s2.182-.047,2.449-1.976",
    transform: "translate(-11.968 -26.434)",
    fill: "none",
    stroke: "#005682",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    d: "M904.628,664.278a8.237,8.237,0,0,0,0,5.991",
    transform: "translate(-2.298 -10.541)",
    fill: "none",
    stroke: "#005682",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    d: "M900.077,662.59a10.414,10.414,0,0,0,0,7.435",
    transform: "translate(-1 -9.549)",
    fill: "none",
    stroke: "#005682",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmBell);
export default __webpack_public_path__ + "static/media/alarm-bell.ee0a2aba77c2c797bd52e34ffba5f489.svg";
export { ForwardRef as ReactComponent };